export default function handleTimeEstimates() {
    // check all time estimates to see if they're empty 

    // course cards
    try {
        let timeEstimates = document.querySelectorAll('.course-time.coursebox-callout span');
        for (let time of timeEstimates) {
            if (time.innerHTML === '') {
                time.parentElement.style.display = 'none';
            }
        }
    } catch {
    }

    // learning path cards
    try {
        let timeEstimates = document.querySelectorAll('.sj-page-curriculum span.sj-lesson-time');
        for (let time of timeEstimates) {
            if (time.innerHTML === '') {
                time.style.display = 'none';
            }
        }
    } catch {
    }

    // course detail pages
    try {
        let timeEstimates = document.querySelectorAll('.sj-page-detail-course span.sj-lesson-time');
        for (let time of timeEstimates) {
            if (time.innerHTML === '') {
                time.style.display = 'none';
            }
        }
    } catch {
    }
};
